$(document).ready(function() {
    
    $(document).on('click', '.line_item_plus', async function() {
        let varId = $(this).attr('data-active-variant');
        let inputElement = $(this).siblings('.value-contant').find('.quantity-input');
        let currentQuantity = parseInt(inputElement.val());
        let newQuantity = currentQuantity + 1;
        
        await updateCartQuantity(varId, newQuantity, inputElement, $(this).closest('.line-item'));
    });

   
    $(document).on('click', '.line_item_minus', async function() {
        let varId = $(this).attr('data-active-variant');
        let inputElement = $(this).siblings('.value-contant').find('.quantity-input');
        let currentQuantity = parseInt(inputElement.val());
        let newQuantity = currentQuantity - 1;
        
        if (newQuantity < 1) {
            newQuantity = 1; 
        }
        
        await updateCartQuantity(varId, newQuantity, inputElement, $(this).closest('.line-item'));
    });


    async function updateCartQuantity(variantId, newQuantity, inputElement, lineItemElement) {
        try {
            const formData = {
                'id': variantId,
                'quantity': newQuantity
            };
            
            const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error("Error updating cart quantity", errorData);
                return;
            }

            const cartChangeResponse = await response.json();
            
            
            inputElement.val(newQuantity);
            
            // Refresh the cart data
            const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const cartData = await cartResponse.json();
         
            
            updateCartUI(cartData, lineItemElement, variantId);

        } catch (error) {
            console.error('Error:', error);
        }
    }

    function updateCartUI(cart, lineItemElement, variantId) {
        
        let cartItemCount = cart.item_count;
        $('cart-count.count-bubble').text(cartItemCount);
        $('.cart .item-count').removeClass('sk-hidden');

       
        let item = cart.items.find(item => item.variant_id == variantId);
      console.log("item",item)

        if (item) {
            let finalPrice = (item.final_line_price / 100).toLocaleString('da-DK', {
                style: 'currency',
                currency: 'DKK'
            });

            let originalPrice = (item.original_line_price / 100).toLocaleString('da-DK', {
                style: 'currency',
                currency: 'DKK'
            });
             lineItemElement.find('sale-price.text-subdued').each(function () {
            let srOnlyText = $(this).find('.sr-only').prop('outerHTML'); 
            $(this).html(`${srOnlyText}${finalPrice}`);
        });

            
            lineItemElement.find('.text-on-sale').text(finalPrice);
            lineItemElement.find('.compare-at-price').text(originalPrice);
           
        }

       
        let totalPrice = (cart.total_price / 100).toLocaleString('da-DK', {
            style: 'currency',
            currency: 'DKK'
        });
        $('.h5.ctotal').text(totalPrice); 
    }
$(".horizontal-product__variants").each(function () {
        let $parent = $(this);
        let $variants = $parent.find(".Custom_swatches");
        let totalVariants = $variants.length;
        let batchSize = 3; // Har baar 4 items show karenge
        let defaultVisible = 3; // Pehle load pe kitne dikhne chahiye
        let currentIndex = 0; // Current batch ka index

        function showVariants(startIndex) {
            $variants.addClass("hided_vararint"); // Sabko hide karo
            let endIndex = startIndex + batchSize;

            // Agar endIndex total se zyada hai toh jitne bache hain utne hi dikhaye
            $variants.slice(startIndex, Math.min(endIndex, totalVariants)).removeClass("hided_vararint");
        }

        // Pehle 3 variants ko "not_hided" class ke saath dikhana
        $variants.addClass("hided_vararint");
        $variants.slice(0, defaultVisible).removeClass("hided_vararint").addClass("not_hided");

        $parent.find(".arrow_left").click(function () {
            currentIndex += batchSize;

            // Jab last batch dikh chuka ho, toh wapas "not_hided" wale pe aaye
            if (currentIndex >= totalVariants) {
                currentIndex = 0;
                $variants.addClass("hided_vararint"); // Sabko hide karo
                $parent.find(".not_hided").removeClass("hided_vararint"); // Sirf pehle 3 dikhane waale show karo
            } else {
                showVariants(currentIndex);
            }
        });
    });


});

document.addEventListener("DOMContentLoaded", function () {
  function updateGalleryOnLoad() {
    let selectedInput = document.querySelector(".variant-picker__option-values input.media_swatch_custom:checked");
    if (selectedInput) {
      let current = selectedInput.getAttribute("value");
      if (!current) {
        return;
      }
      let thumbnailItems = document.querySelectorAll(".product-gallery--desktop-grid .product-gallery__media");
      let thumbnailItems_mbl = document.querySelectorAll(".product-gallery__thumbnail-list .product-gallery__thumbnail");
      let isFirstMatch = true;
      
      thumbnailItems.forEach(function (item) {
        let currentImg = item.getAttribute("media-alt");
        let booleanCheck = currentImg.trim() === current.trim();
        if (booleanCheck) {
          if (isFirstMatch) {
            item.style.gridColumn = "span 2"; 
            isFirstMatch = false;
          }
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
       thumbnailItems_mbl.forEach(function (item) {
        let currentImg = item.getAttribute("var_image");
        let booleanCheck = currentImg.trim() === current.trim();
        if (booleanCheck) {
          if (isFirstMatch) {
            isFirstMatch = false;
          }
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    }
  } 

  updateGalleryOnLoad();

  document.body.addEventListener("click", function (event) {
    if (event.target && event.target.matches(".variant-picker__option-values input.media_swatch_custom")) {
      updateGalleryOnLoad();
    }
  });
});


 function updateVariantCombinations() {
    if (!window.productVariants) return;

    var selectedColor = $('input[name="option1"]:checked').val();

    $('input[name="option2"]').each(function () {
      var sizeValue = $(this).val();
      var inputId = $(this).attr('id');
      var $label = $('label[for="' + inputId + '"]');

      var matchedVariant = window.productVariants.find(function (variant) {
        return (
          variant.option1 === selectedColor &&
          variant.option2 === sizeValue
        );
      });

      // ONLY hide / show — nothing else
      if (!matchedVariant || matchedVariant.hide_variant === true) {
        $label.hide();
      } else {
        $label.show();
      }
    });
  }

  // Page load
  document.addEventListener('DOMContentLoaded', function () {
    updateVariantCombinations();
  });

  // On change
  $(document).on(
    'change',
    'input[name="option1"], input[name="option2"]',
    function () {
      updateVariantCombinations();
    }
  );
